/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment-timezone";
import { DataTableList } from "../../../components/DataTable/DataTableList";
import TopBar from "../../../components/TopBar";
import DeleteConfirmationPopup from "../../../components/DeleteConfirmationPopup";
import { getBanners, deleteBanners } from "../../../api/bannerApi";

import Delete from "../../../assets/images/delete.svg";
import penIcon from "../../../assets/images/pen-img.svg";
import searchIcon from "../../../assets/images/icon-search.svg";

import styles from './banner.module.css'

const BannerList = () => {

    const popupRef = useRef()
    const dropdownRef = useRef()

    const [isLoadingData, setIsLoadingData] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [columnWidths, setColumnWidths] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [toggleSelect, setToggleSelect] = useState(false);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null);
    const [searchInput, setSearchInput] = useState('');

    const [bannerList, setBannerList] = useState([])

    const fetchBanners = async () => {
        try {
            setIsLoadingData(true);
            const response = await getBanners(
                {
                    page: currentPage,
                    search: searchInput,
                    sortBy: 'createdAt',
                }
            );
            if (response?.data?.result?.length <= 0) {
                setIsLoadingData(false);
            }
            if (response?.success) {
                setBannerList(response?.data?.result || []);
                setTotalPage(response?.data?.totalPages || []);
            }
        } catch (error) {
            console.log('Error fetching banners:', error);
            setBannerList([]);
            setIsLoadingData(false);
        }
    };

    useEffect(() => {
        fetchBanners();
    }, [currentPage]);

    const calculateColumnWidths = async () => {
        return new Promise((resolve) => {
            const tempWidths = bannerList?.reduce((acc, row) => {
                Object?.keys(row)?.forEach((key) => {
                    const dataValue = row[key]?.toString();
                    const title = row[key];

                    let maxContentLength = Math?.max(dataValue?.length, title?.length);

                    if (!acc[key] || maxContentLength > acc[key]) {
                        acc[key] = maxContentLength;
                    }
                });
                return acc;
            }, {});

            if (tempWidths !== undefined) {
                const widthMap = Object?.keys(tempWidths)?.reduce((acc, key) => {
                    acc[key] = `${tempWidths[key] * 10 + 40}px`;
                    return acc;
                }, {});
                setColumnWidths(widthMap);
            }
            resolve();
        });
    };

    useEffect(() => {
        if (bannerList?.length > 0) {
            calculateColumnWidths();
        }
    }, [bannerList]);

    useEffect(() => {
        const handleClickOutside = (event) => {

            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setShowDeletePopup(false);
            }
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                // setOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (Object?.keys(columnWidths)?.length > 0) {
            setTimeout(() => {
                setIsLoadingData(false);
            }, 1000);
        }
    }, [columnWidths]);

    const handleMasterCheckboxChange = () => {
        if (isAllSelected) {
            setSelectedRows([]);
        } else {
            setSelectedRows(bannerList?.map((row) => (row?.bannerId && row?.bannerTitle !== 'Main banner')));
        }
        setIsAllSelected(!isAllSelected);
    };

    const confirmDelete = async () => {
        if (!deleteTarget) return;

        try {
            if (deleteTarget.type === "single") {
                await deleteBanners([deleteTarget?.row?.bannerId]);
            }

            if (deleteTarget.type === "multiple") {
                await deleteBanners(deleteTarget?.rows);
                setSelectedRows([]);
                setIsAllSelected(false);
                setToggleSelect(prev => !prev);
            }

            await fetchBanners();
        } catch (error) {
            console.error('Error deleting banners:', error);
        }

        setShowDeletePopup(false);
        setDeleteTarget(null);
    };

    const customStyles = {
        headCells: {
            style: {
                fontWeight: 500,
                fontSize: '14px',
            },
        },
    };

    const columns = [
        {
            name: 'Banner Title',
            selector: (row) => row?.bannerTitle,
            cell: (row) => <div className='editTitle'><Link to={`/appearance/banner/${row?.bannerId}`}>{row?.bannerTitle}</Link></div>,
            sortable: true,
            minWidth: columnWidths['bannerTitle'] && (parseInt(columnWidths['bannerTitle']) + 50 > 300) ? '300px' : `${parseInt(columnWidths['bannerTitle']) + 50}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },

        },
        {
            name: 'Created At',
            selector: (row) => row?.createdAt,
            cell: (row) => <div>{moment(row?.createdAt).tz("Asia/Kolkata").format("DD MMM, YYYY")}</div>,
            sortable: true,
            width: columnWidths['createdAt'] && `${parseInt(columnWidths['createdAt']) - 90}px`,
            style: { width: columnWidths['createdAt'] || '150px', paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },
        },
        {
            name: "Actions",
            cell: (row) => (
                <div className="action-buttons">
                    <Link to={`/appearance/banner/${row?.bannerId}`}>
                        <button className="edit-btn"><img src={penIcon} alt="pen-icon" /></button>
                    </Link>
                    <button className="delete-btn" onClick={() => {
                        if (row?.bannerTitle !== 'Main banner') {
                            setDeleteTarget({ type: "single", row });
                            setShowDeletePopup(true);
                        }
                    }}><img src={Delete} alt="delete-icon" />
                    </button>
                </div>
            ),
            width: "90px"
        }
    ];

    const handleSearch = async () => {
        await fetchBanners()
    }

    return (
        <div className={`${styles.bannerList} ${bannerList?.length <= 10 && `${styles.bannerListHeight}`}`}>
            <TopBar />

            <div className={`${styles.bannerDatatableList}`}>

                <div className={`${styles.bannerHeader}`}>
                    <div className={`${styles.leftSide}`}>
                        <div className={`${styles.searchBar}`}>
                            <img src={searchIcon} alt="Search" />
                            <input
                                type="text"
                                placeholder="Search by banner title..."
                                value={searchInput}
                                onChange={(e) => setSearchInput(e.target.value)}
                                onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                            />
                        </div>
                        <button className={`add-btn`} onClick={() => handleSearch()}>Search</button>
                    </div>
                    <div className={`${styles.actionButtonsDeleteAdd}`}>
                        <div className={`${styles.leftSide}`}>
                        </div>
                        <Link to='/appearance/add-banner'>
                            <button className='add-btn'>Add Banner</button>
                        </Link>
                        {selectedRows?.length > 0 && (
                            <div className={`${styles.deleteSelectedBtn}`} onClick={() => {
                                setDeleteTarget({ type: "multiple", rows: selectedRows });
                                setShowDeletePopup(true);
                            }}>
                                <img src={Delete} alt="delete-icon" />
                            </div>
                        )}
                    </div>
                </div>

                <div className={`pagesTable dataTable-list ${bannerList?.length <= 10 && 'dataTable-border-list'} ${(isLoadingData) ? 'loading-list' : ''} `}>
                    <DataTableList
                        columns={columns}
                        data={bannerList}
                        onSelectedRowsChange={({ selectedRows }) => {
                            const selectedIds = selectedRows?.map((row) => row?.bannerId);
                            setSelectedRows(selectedIds);
                            setIsAllSelected(selectedIds.length === bannerList?.length);
                        }}
                        progressPending={isLoadingData}
                        currentPage={currentPage}
                        onChangePage={setCurrentPage}
                        paginationTotalRows={totalPage}
                        selectableRows
                        selectAllRows={isAllSelected}
                        clearSelectedRows={toggleSelect}
                        onSelectAllChange={handleMasterCheckboxChange}
                        customStyles={customStyles}
                        selectableRowsComponent="input"
                        selectableRowDisabled={(row) => row.bannerTitle === 'Main banner'}
                        progressComponent={<div className="loader-container"> <div className="loader"></div> </div>}
                    />
                </div>
            </div>
            <DeleteConfirmationPopup
                showDeletePopup={showDeletePopup}
                setShowDeletePopup={setShowDeletePopup}
                reference={popupRef}
                title={deleteTarget?.type === "single" ? 'banner' : selectedRows?.length === 1 ? 'banner' : `banners`}
                description={deleteTarget?.type === "single" ? `Are you sure you want to delete banner ${deleteTarget?.row?.bannerTitle}?` : selectedRows?.length === 1 ? `Are you sure you want to delete banner?` : `Are you sure you want to delete ${selectedRows?.length} banners?`}
                confirmDelete={confirmDelete}
            />
        </div>
    )
}
export default BannerList;